export const FEATURE_LOCATION_GROUP_BY_CONTINENT = 'continent';
